import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field as BaseField } from "rc-field-form";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";
import Field from "../../../../../../../../../components/Field";
import Checkbox from "../../../../../../../../../components/Inputs/Checkbox";
import Modal from "../../../../../../../../../components/Modal";
import { firstToUpper } from "../../../../../../../../../utils/helpers/string";
import { useVisible } from "../../../../../../../../../utils/hooks/useVisible";
import { CONSECUTIVE_OT_RULE_CONFIG } from "./config";
import ParametersForm from "./ParametersForm";

function ConsecutiveOvertimeRule({ ruleType, disabled }) {
	const { t } = useTranslation();
	const config = CONSECUTIVE_OT_RULE_CONFIG[ruleType];

	const { visible, open: openModal, close: closeModal } = useVisible();

	if (!config) {
		return null;
	}

	const { overtimeKey, checkboxLabelKey, modalTitleKey } = config;
	const getFieldName = (name) => ["overtime", overtimeKey, name];

	const checkboxId = `${overtimeKey}-checkbox`;

	return (
		<div className="calculation-group-rule">
			<div className="d-flex align-items-center mr-1 w-100">
				<Field name={getFieldName("status")} valuePropName="checked" noStyle className="mb-0">
					<Checkbox id={checkboxId} disabled={disabled}>
						{t(checkboxLabelKey)}
					</Checkbox>
				</Field>
			</div>

			<BaseField shouldUpdate noStyle>
				{(_, __, { getFieldValue, getFieldError }) => {
					const data = getFieldValue(["overtime", overtimeKey]);
					const status = data?.status;
					const error = getFieldError(getFieldName("value"));
					return (
						<>
							<div className="d-flex align-items-center">
								<Field
									name={getFieldName("value")}
									rules={
										status
											? [
												{
													required: status,
													message: t("required-consecutive-day"),
												},
											]
											: undefined
									}
									noStyle
									dependencies={[getFieldName("status")]}
									className="mb-0"
								>
									<Input type="number" size="sm" className="border-primary" disabled />
								</Field>

								<BaseField name={getFieldName("defaultPayCode")} hidden />
								<BaseField name={getFieldName("payCodes")} hidden />
								<BaseField name={getFieldName("hourTypes")} hidden />
								<BaseField name={getFieldName("overtimes")} hidden />
								<BaseField name={getFieldName("calculateOtherOvertime")} hidden />
								<BaseField name={getFieldName("premiumPayCode")} hidden />
								<BaseField name={getFieldName("splitOvertime")} hidden />
								<BaseField name={getFieldName("unitPayCode")} hidden />

								<p className="text-sm mx-2 mb-0 text-center">{firstToUpper(t("day"))}</p>
							</div>

							<div className="d-flex align-items-center justify-content-end">
								<FontAwesomeIcon
									className="text-sm cursor-pointer"
									icon={faPen}
									// the user should be able to see the modal even if the form is disabled
									// if the form is disabled, the save button will be hidden and the inputs will be disabled
									onClick={status ? openModal : undefined}
								/>
							</div>

							{error && <p className="text-danger text-sm">{error}</p>}

							{visible && (
								<Modal
									title={t(modalTitleKey)}
									isOpen={visible}
									close={closeModal}
									centered
									size="lg"
								>
									<ParametersForm
										overtimeKey={overtimeKey}
										close={closeModal}
										overtime={data ?? {}}
										disabled={disabled}
									/>
								</Modal>
							)}
						</>
					);
				}}
			</BaseField>
		</div>
	);
}

export default ConsecutiveOvertimeRule;
